import { createSelector } from 'reselect';

import getElectConsumptionDataSelector from './getElectConsumptionDataSelector';

export default createSelector([getElectConsumptionDataSelector], (consumptionData) => {
  const uniqueLocationIds = new Set<number>();
  consumptionData.forEach((data) => {
    if (data.location_id) {
      uniqueLocationIds.add(data.location_id);
    }
  });
  return uniqueLocationIds.size;
});
